var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiTruckFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 6.66797H16.6673L19.1673 10.048V15.0013H17.4715C17.3711 15.6956 17.024 16.3304 16.4937 16.7896C15.9634 17.2488 15.2854 17.5015 14.584 17.5015C13.8825 17.5015 13.2045 17.2488 12.6742 16.7896C12.1439 16.3304 11.7968 15.6956 11.6965 15.0013H7.47148C7.37242 15.6965 7.02583 16.3327 6.49538 16.7929C5.96494 17.2531 5.28625 17.5065 4.58398 17.5065C3.88172 17.5065 3.20303 17.2531 2.67259 16.7929C2.14214 16.3327 1.79555 15.6965 1.69648 15.0013H0.833984V5.0013C0.833984 4.78029 0.921782 4.56833 1.07806 4.41205C1.23434 4.25577 1.4463 4.16797 1.66732 4.16797H13.334C13.555 4.16797 13.767 4.25577 13.9232 4.41205C14.0795 4.56833 14.1673 4.78029 14.1673 5.0013V6.66797ZM14.1673 8.33464V10.8346H17.5006V10.5971L15.8273 8.33464H14.1673Z",
    fill: "#8893A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiTruckFill);
export default __webpack_public_path__ + "static/media/ri_truck-fill.3e8b2fd931db357133d621df5968fdb5.svg";
export { ForwardRef as ReactComponent };